import React, { useState } from "react";
import { X, Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API, authHeaders } from "./shared";

export default function LocationForm({ onClose, onSave }) {
  const [form, setForm] = useState({ code: "", name: "", zone: "", aisle: "", shelf: "", level: "", note: "" });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.code) return toast.error("Il codice posizione e obbligatorio");
    setSaving(true);
    try {
      await axios.post(`${API}/admin/warehouse/locations`, form, authHeaders());
      toast.success("Posizione creata");
      onClose();
      onSave();
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center pt-20">
      <div className="bg-white rounded-sm w-full max-w-md shadow-xl m-4" data-testid="location-form">
        <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-200">
          <h2 className="font-heading font-bold text-lg uppercase tracking-wide">Nuova Posizione</h2>
          <button onClick={onClose} className="p-2 text-zinc-400 hover:text-zinc-600"><X size={20} /></button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Codice *</label>
            <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} placeholder="A-01-01"
              className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm font-mono" data-testid="loc-code" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Nome</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Corsia A, Scaffale 1, Piano 1"
              className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Zona</label>
              <input value={form.zone} onChange={e => setForm({ ...form, zone: e.target.value })} placeholder="A" className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm" /></div>
            <div><label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Corsia</label>
              <input value={form.aisle} onChange={e => setForm({ ...form, aisle: e.target.value })} placeholder="01" className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm" /></div>
            <div><label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Scaffale</label>
              <input value={form.shelf} onChange={e => setForm({ ...form, shelf: e.target.value })} placeholder="01" className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm" /></div>
            <div><label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Piano</label>
              <input value={form.level} onChange={e => setForm({ ...form, level: e.target.value })} placeholder="1" className="w-full border border-zinc-200 rounded-sm px-3 py-2 text-sm" /></div>
          </div>
          <button type="submit" disabled={saving} data-testid="loc-save-btn"
            className="w-full bg-[#09090B] text-white h-11 font-bold uppercase tracking-wide rounded-sm hover:bg-zinc-800 transition-colors text-sm disabled:opacity-50 flex items-center justify-center gap-2">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <MapPin size={16} />} Crea Posizione
          </button>
        </form>
      </div>
    </div>
  );
}
